import { isEmptyArray } from "formik";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useRequest, useRouterParams } from "../../abstracts";
import {
  GetEmployeeYOSHistoryDetails,
  getEmployeeYOSDetails,
} from "../../services";
import "../../styles/components/CensusRetirementCard.scss";
import { usDateFormat } from "../../utils";
import LoaderWrapper from "../LoaderWrapper";
import SliderPanel from "../SliderPanel";
import SponsorCard from "../SponsorCards";
import { Col, Row, Table } from "react-bootstrap";

const CensusRetirementCard = (props) => {
  const { data, isMainCard, isERACard, isNRACard, cardName } = props;
  const { planId, censusId } = useRouterParams();
  const [historySliderOpen, setHistorySliderOpen] = useState(false);
  const [viewUpdatedYOSSlider, setViewUpdatedYOSSlider] = useState(false);
  const [currentEmployeeYos, setCurrentEmployeeYOS] = useState({});
  const normalRetirementCardLabel = [
    { label: "Status", columnName: "status" },
    { label: "Date", columnName: "date" },
  ];
  const [employeeHistoryDetails, setEmployeeHistoryDetails] = useState([]);

  const { response: getEmployeeYOS, loading: load } = useRequest({
    method: getEmployeeYOSDetails,
    payload: { planId: planId, employeeId: censusId },
    defaultResponse: [],
  });

  var retirementYos =
    getEmployeeYOS[getEmployeeYOS?.length - 1]?.yearsOfService;

  const getHistoryDetails = (employeeYos) => {
    setViewUpdatedYOSSlider(true);
    GetEmployeeYOSHistoryDetails(employeeYos?.id).then((response) => {
      setEmployeeHistoryDetails(response);
    });
    setCurrentEmployeeYOS(employeeYos);
  };

  const getPreviousValue = (index) => {
    return employeeHistoryDetails[index + 1]?.yearsOfService;
  };
  const getCurrentValue = (index) => {
    return employeeHistoryDetails[index]?.yearsOfService;
  };

  const retirementCardLabel = [
    { label: "", columnName: "employerName" },
    //{ label: "Eligibility YOS", columnName: "eligibilityYearsOfService" },
    //{ label: "Age of Participant", columnName: "ageOfParticipant" },
    { label: "Years Of Service", columnName: "vestingYearsOfService" },
    { label: "Years of Participation", columnName: "yearsOfParticipation" },
  ];
  //var year;
  //var month;
  // if (isMainCard) {
  //   var date = new Date();
  //   var birthday = data.employerDOB ? new Date(data.employerDOB) : null;
  //   year = date.getFullYear() - birthday.getFullYear();
  //   var datenow;
  //   if (date.getMonth() >= birthday.getMonth()) {
  //     month = date.getMonth() - birthday.getMonth();
  //   } else {
  //     year--;
  //     month = 12 + (date.getMonth() - birthday.getMonth());
  //   }
  //   if (date.getDate() >= birthday.getDate()) {
  //     datenow = date.getDate() - birthday.getDate();
  //   } else {
  //     month--;
  //     datenow = 31 + (date.getDate() - birthday.getDate());
  //     if (month < 0) {
  //       month = 11;
  //       year--;
  //     }
  //   }
  // }
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {isERACard && <div className="source-name mb-10">Early Retirement</div>}
      {isNRACard && <div className="source-name mb-10">Normal Retirement</div>}
      <div className={`${cardName}`}>
        {isMainCard &&
          retirementCardLabel.map((item, index) => {
            if (
              index == 0 &&
              data.ageInYears != null &&
              data.ageInMonths != null
            )
              return (
                <>
                  <div className="col-display w-33">
                    <p className="source-name">{data.employeeName}</p>
                    {/* <p className="label">
                    DOB: {data.employeeDOB} ({data.ageInYears}{" "}
                    {data.ageInYears > 1 ? "Years" : "Year"} {data.ageInMonths}{" "}
                    {data.ageInMonths > 1 ? "months" : "month"})
                  </p> */}
                  </div>
                  <div className="dotline-separator"></div>
                  <div className="col-display w-22">
                    <p className="label">Age of participant</p>
                    <p className="col-content">
                      {data.ageInYears} {data.ageInYears > 1 ? "Years" : "Year"}{" "}
                      {data.ageInMonths}{" "}
                      {data.ageInMonths > 1 ? "months" : "month"}
                    </p>
                  </div>
                </>
              );
            else if (
              index == 0 &&
              data.ageInYears == null &&
              data.ageInMonths == null
            )
              return (
                <>
                  <div className="col-display w-33 text-align-center mt-2">
                    <p className="source-name">{data.employeeName}</p>
                    {/* <p className="label">DOB: {data.employeeDOB}</p> */}
                  </div>
                  <div className="dotline-separator"></div>
                  <div className="col-display w-22">
                    <p className="label">Age of Participant</p>
                    <p className="col-content">NA</p>
                  </div>
                </>
              );
            else if (index == 1)
              if (cardName === "retirementcard") {
                return (
                  <>
                    <div className="dotline-separator"></div>
                    <div className="col-display w-22">
                      <p className="label">{item.label}</p>
                      <p className="col-content">
                        {retirementYos}{" "}
                        {retirementYos ? (
                          <Link
                            onClick={() => {
                              setHistorySliderOpen(true);
                            }}
                            className={"ml-3"}
                          >
                            {" "}
                            View History
                          </Link>
                        ) : (
                          "NA"
                        )}
                      </p>
                    </div>
                  </>
                );
              } else {
                return (
                  <>
                    <div className="dotline-separator"></div>
                    <div className="col-display w-22">
                      <p className="label">{item.label}</p>
                      <p className="col-content">
                        {data[item.columnName]}{" "}
                        {data[item.columnName] ? (
                          <Link
                            onClick={() => {
                              setHistorySliderOpen(true);
                            }}
                            className={"ml-3"}
                          >
                            {" "}
                            View History
                          </Link>
                        ) : (
                          "NA"
                        )}
                      </p>
                    </div>
                  </>
                );
              }
            else if (index == 2)
              return (
                <>
                  <div className="dotline-separator"></div>
                  <div className="col-display w-22">
                    <p className="label">{item.label}</p>
                    <p className="col-content">
                      {data[item.columnName] ? data[item.columnName] : "NA"}
                      {data[item.columnName]
                        ? data[item.columnName] > 1
                          ? " years"
                          : " year"
                        : ""}
                    </p>
                  </div>
                </>
              );
          })}
        {(isNRACard || isERACard) &&
          normalRetirementCardLabel.map((item, index) => {
            return (
              <>
                {index != 0 && <div className="dotline-separator"></div>}
                <div className="col-display w-50">
                  <p className="label">{item.label}</p>
                  <p className="col-content">
                    {data[item.columnName] ? data[item.columnName] : "NA"}
                  </p>
                </div>
              </>
            );
          })}
      </div>

      <SliderPanel
        isOpen={historySliderOpen}
        showBackButton={true}
        backdropClicked={() => {
          setHistorySliderOpen(false);
        }}
        size={50}
        onClose={() => setHistorySliderOpen(false)}
        showCancel={false}
      >
        <LoaderWrapper isLoading={load}>
          {!isEmptyArray(getEmployeeYOS) ? (
            getEmployeeYOS?.map((employeeYos, ind) => {
              return (
                <div>
                  <div className="updatedfields-card mt-4">
                    <SponsorCard
                      value={`${usDateFormat(
                        employeeYos?.startDate
                      )} - ${usDateFormat(employeeYos?.endDate)}`}
                      title={"Computation period"}
                      type="text"
                    />
                    <SponsorCard
                      value={employeeYos?.yearsOfService}
                      title={"Years Of Service"}
                      type="text"
                    />
                    <SponsorCard
                      value={employeeYos?.Comments ?? "-"}
                      title={"Comments"}
                      type="text"
                    />
                    <SponsorCard
                      value={"View History"}
                      type="link"
                      onClick={() => getHistoryDetails(employeeYos)}
                    ></SponsorCard>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="updatedfields-card mt-4 p-2">No Record Found</div>
          )}
        </LoaderWrapper>
      </SliderPanel>
      <SliderPanel
        isOpen={viewUpdatedYOSSlider}
        showBackButton={true}
        backdropClicked={() => {
          setViewUpdatedYOSSlider(false);
        }}
        size={50}
        onClose={() => setViewUpdatedYOSSlider(false)}
        showCancel={false}
      >
        <LoaderWrapper isLoading={load}>
          <>
            <Row className="d-flex justify-content-between Ecr-Payroll-Details">
              <Col>Field Name</Col>
              <Col>Previous Value</Col>
              <Col>Updated Value</Col>
              <Col md="4">Computation Period</Col>
            </Row>
            <hr></hr>
            {!isEmptyArray(employeeHistoryDetails) && (
              <Row className="d-flex justify-content-between mt-3">
                <Col>Years Of Service</Col>
                <Col>{employeeHistoryDetails[0]?.yearsOfService}</Col>
                <Col>{currentEmployeeYos?.yearsOfService}</Col>
                <Col md="4">
                  {`${usDateFormat(
                    currentEmployeeYos?.startDate
                  )} - ${usDateFormat(currentEmployeeYos?.endDate)}`}
                </Col>
              </Row>
            )}
            {!isEmptyArray(employeeHistoryDetails) &&
              employeeHistoryDetails?.map(
                (employee, index) =>
                  index !== employeeHistoryDetails?.length - 1 && (
                    <Row className="d-flex justify-content-between mt-3">
                      <Col>Years Of Service</Col>
                      <Col>{getPreviousValue(index)}</Col>
                      <Col>{getCurrentValue(index)}</Col>
                      <Col md="4">
                        {`${usDateFormat(employee?.startDate)} - ${usDateFormat(
                          employee?.endDate
                        )}`}
                      </Col>
                    </Row>
                  )
              )}
            {!isEmptyArray(employeeHistoryDetails) && (
              <Row className="d-flex justify-content-between mt-3">
                <Col>Years Of Service</Col>
                <Col>
                  {
                    employeeHistoryDetails[employeeHistoryDetails?.length - 1]
                      ?.yearsOfService
                  }
                </Col>
                <Col>{"-"}</Col>
                <Col md="4">
                  {`${usDateFormat(
                    employeeHistoryDetails[0]?.startDate
                  )} - ${usDateFormat(employeeHistoryDetails[0]?.endDate)}`}
                </Col>
              </Row>
            )}
            {isEmptyArray(employeeHistoryDetails) && (
              <div className="updatedfields-card mt-4 p-2">No Record Found</div>
            )}
          </>
        </LoaderWrapper>
      </SliderPanel>
    </div>
  );
};

export default CensusRetirementCard;
